import { EventGQL, PlayerDataGQL } from '../../Api'
import { SEO_DEFAULTS, SeoDeafultType } from '../../Constants/seo'
import { timeStampToDate } from '../formatting'

/**
 * Generate matchup SEO tags
 */
export const generateMatchupSEOTags = (eventInfo: EventGQL | null) => {
  if (!eventInfo) return SEO_DEFAULTS.matchup

  const awayTeam = eventInfo?.awayTeam?.fullName || 'TBA'
  const homeTeam = eventInfo?.homeTeam?.fullName || 'TBA'
  const eventDate = timeStampToDate(eventInfo?.startTime)?.date
  let tags: { [key: string]: string } = {
    title: `${awayTeam} vs ${homeTeam} - ${eventDate}`,
    description: `Game previews and key matchups to watch for${awayTeam} vs ${homeTeam} on ${
      eventDate ?? 'TBA'
    }.`,
    keywords: `${awayTeam}, ${homeTeam}, matchup, where to watch`,
  }
  return tags
}

/**
 * Generate player SEO tags
 */
export const generatePlayerSEOTags = (player: PlayerDataGQL | null, tab?: string) => {
  if (!player) return SEO_DEFAULTS.player

  let capitalTab = 'Profile'
  if (tab) {
    capitalTab = tab.charAt(0).toUpperCase() + tab.slice(1)
  }
  let tags: SeoDeafultType = {
    title: `${player.firstName} ${player.lastName} - ${capitalTab}`,
    description: `View ${player.firstName} ${player.lastName}'s player profile, stats, and media.`,
    keywords: `${player.firstName} ${player.lastName}, ${
      player?.currentTeam?.fullName || ''
    }, profile, player stats`,
  }
  return tags
}
